import { StartingPoint } from "../../interfaces/StartingPoint.interface";

export const getStartingPoint = (
  startingPoints: StartingPoint[],
  id: string | null
): StartingPoint | null => {
  const startingPoint = startingPoints.find(
    (startingPoint) => startingPoint.id === id
  );

  return startingPoint || null;
};
